import type { ChangeEvent, FC } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button, SxProps, styled } from "@mui/material";

type ImgUploadBtnProps = {
  onImgUpload: (event: ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps;
  isFullWidth?: boolean;
  size?: "medium" | "small" | "large";
  label?: string;
  variant?: "contained" | "outlined" | "text";
  disabled?: boolean;
  color?: "primary" | "secondary";
};

export const ImgUploadBtn: FC<ImgUploadBtnProps> = ({
  onImgUpload,
  sx,
  isFullWidth = true,
  size = "medium",
  label = "上传图片",
  variant = "contained",
  disabled = false,
  color = "primary",
}) => (
  <Button
    fullWidth={isFullWidth}
    component="label"
    variant={variant}
    startIcon={<CloudUploadIcon />}
    sx={{
      fontWeight: 800,
      marginTop: "16px",
      ...sx,
    }}
    size={size}
    disabled={disabled}
    color={color}
  >
    {label}
    <VisuallyHiddenInput
      type="file"
      onChange={onImgUpload}
      multiple={false}
      accept="image/*"
      onClick={(e) => {
        (e.target as HTMLInputElement).value = "";
      }}
    />
  </Button>
);

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
